module.exports = __webpack_public_path__ + "static/UnboundWorldsApart2-d0cc23fb38a657e5b9a0a70cd926d78c.webp";